// extracted by mini-css-extract-plugin
export default {"form":"AreaForm_form__aT7de","button":"AreaForm_button__4biry","formGroup":"AreaForm_formGroup__ZVV+A","textEditor":"AreaForm_textEditor__nB6dY"};